import { getProgramKeys, pickUpTimings } from '../../../constants';
import { Program, ProgramDetails, Question } from '../../../pages/Registration';
import { contentDateFormat } from '../../../utils/commonFunctions';
import styles from './index.module.scss';
import RazorPay from '../../../assets/images/RazorPay.svg';
import { PAYMENT_CONTENT, UI_CONSTANTS } from '../../../utils/registrationUtils';

const CustomCard = ({ content, cardContent, allocatedProgram, question }: { 
  content: string | null, 
  cardContent: any, 
  allocatedProgram: Program | null | undefined, 
  question: Question 
}) => {
  return (
    <div className={styles.cardContainer}>
      {cardContent.dialogueContentType !== "dynamic" ? (
        <div className={styles.contentContainer}>
          <div className={styles.ImageContainer}>
            <img 
              src={RazorPay} 
              alt={UI_CONSTANTS.RAZORPAY_ALT_TEXT}  
              className={styles.RazorPay}
            />
          </div>
          <div className={styles.cardContent}>
            <div>{PAYMENT_CONTENT.METHOD_SELECTION}</div>
            <div>
              {PAYMENT_CONTENT.REDIRECT_INFO} 
              <b><i> {PAYMENT_CONTENT.FORMATTED_PAYMENT_TEXT} </i></b> and <b><i> {PAYMENT_CONTENT.FORMATTED_WALLET_TEXT}</i></b>
            </div>
          </div>
        </div>
      ) : (
        <p className={styles.card_content}>
          {allocatedProgram ? 
            `${pickUpTimings(
              allocatedProgram[getProgramKeys(cardContent.isShow + " " + question.bindingKey)], 
              cardContent.isShow + " " + question.bindingKey, 
              allocatedProgram
            )}` : 
            ""
          }
        </p>
      )}
    </div>
  );
};

export default CustomCard;